module.exports = __webpack_public_path__ + "img/strophoid.0b32d73b.jpg";